// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"v_cp","modalDialog":"v_cp","modal-title":"v_cq","modalTitle":"v_cq","modal-subtitle":"v_cr","modalSubtitle":"v_cr"};